export const PRIVOLITVENA_EUREKO_UPDATED = 'PRIVOLITVENAEUREKO_UPDATED';
export const PRIVOLITVENA_EUREKO_PRIVOLITEV_UPDATED = 'PRIVOLITVENAEUREKO_PRIVOLITEV_UPDATED';
export const PRIVOLITVENA_EUREKO_PRIVOLITEV_Q33_UPDATED = 'PRIVOLITVENAEUREKO_PRIVOLITEV_Q33_UPDATED';